import AuthorAvatar from "%/dynamic-component-editor/standard-components/base-story-card/AuthorAvatar.vue";
import AuthorName from "%/dynamic-component-editor/standard-components/base-story-card/AuthorName.vue";
import StoryTitle from "%/dynamic-component-editor/standard-components/base-story-card/StoryTitle.vue";
import StoryImage from "%/dynamic-component-editor/standard-components/base-story-card/StoryImage.vue";
import StoryMedia from "%/dynamic-component-editor/standard-pages/story-page/StoryMedia.vue";
import StoryCreated from "%/dynamic-component-editor/standard-components/base-story-card/StoryCreated.vue";
import EstimatedReadingTime
  from "%/dynamic-component-editor/standard-components/base-story-card/EstimatedReadingTime.vue";
import StoryContent from "%/dynamic-component-editor/standard-components/base-story-card/StoryContent.vue";
import StoryBody from "%/dynamic-component-editor/standard-pages/story-page/StoryBody.vue";
import HashTags from "%/dynamic-component-editor/standard-components/base-story-card/HashTags.vue";
import EditArticleButton from "%/dynamic-component-editor/standard-elements/articles/elements/EditArticleButton.vue";
import ExclusiveBadge from "%/dynamic-component-editor/standard-components/base-story-card/ExclusiveBadge.vue";
import StoryButton from "%/dynamic-component-editor/standard-components/base-story-card/StoryButton.vue";
import CompletionSetNotStarted from "%/dynamic-component-editor/standard-components/base-story-card/CompletionSetNotStarted.vue";
import CompletionSetStarted from "%/dynamic-component-editor/standard-components/base-story-card/CompletionSetStarted.vue";
import CompletionSetComplete from "%/dynamic-component-editor/standard-components/base-story-card/CompletionSetComplete.vue";
import CompletionStatus from "%/dynamic-component-editor/standard-components/base-story-card/CompletionStatus.vue";
import CompletionToggle from "%/dynamic-component-editor/standard-components/base-story-card/CompletionToggle.vue";
import CompletionProgress from "%/dynamic-component-editor/standard-components/base-story-card/CompletionProgress.vue";
import CompletionPercentage from "%/dynamic-component-editor/standard-components/base-story-card/CompletionPercentage.vue";
import ResumeReadingCta from "%/dynamic-component-editor/standard-pages/story-page/ResumeReadingCta.vue";
import ResumeCard from "%/dynamic-component-editor/standard-elements/ResumeCard.vue";
import WorkoutSetLogger from "%/dynamic-component-editor/standard-pages/story-page/WorkoutSetLogger.vue";
import WorkoutSetProgress from "%/dynamic-component-editor/standard-components/base-story-card/WorkoutSetProgress.vue";
import DownvoteAction from "%/dynamic-component-editor/standard-components/base-story-card/DownvoteAction.vue";
import UpvoteAction from "%/dynamic-component-editor/standard-components/base-story-card/UpvoteAction.vue";
import LikeAction from "%/dynamic-component-editor/standard-components/base-story-card/LikeAction.vue";
import ReportAction from "%/dynamic-component-editor/standard-components/base-story-card/ReportAction.vue";
import ModerationStateBadge
  from "%/dynamic-component-editor/standard-components/base-story-card/ModerationStateBadge.vue";
import ShareButton from "%/dynamic-component-editor/standard-components/base-story-card/ShareButton.vue";
import SelectCollectionButton
  from "%/dynamic-component-editor/standard-components/base-story-card/SelectCollectionButton.vue";
import CommentAction from "%/dynamic-component-editor/standard-components/base-story-card/CommentAction.vue";
import SaveAction from "%/dynamic-component-editor/standard-components/base-story-card/SaveAction.vue";
import DownvoteScore from "%/dynamic-component-editor/standard-components/base-story-card/DownvoteScore.vue";
import UpvoteScore from "%/dynamic-component-editor/standard-components/base-story-card/UpvoteScore.vue";
import VoteScore from "%/dynamic-component-editor/standard-components/base-story-card/VoteScore.vue";
import LikeCount from "%/dynamic-component-editor/standard-components/base-story-card/LikeCount.vue";
import CommentCount from "%/dynamic-component-editor/standard-components/base-story-card/CommentCount.vue";
import SaveCount from "%/dynamic-component-editor/standard-components/base-story-card/SaveCount.vue";
import ShareCount from "%/dynamic-component-editor/standard-components/base-story-card/ShareCount.vue";
import CommentsWidget
  from "%/dynamic-component-editor/standard-pages/story-page/CommentsWidget.vue";
import PublicationName
  from "%/dynamic-component-editor/standard-pages/story-page/PublicationName.vue";
import FolderContents
  from "%/dynamic-component-editor/standard-pages/story-page/FolderContents.vue";
import FolderItemCount
  from "%/dynamic-component-editor/standard-pages/story-page/FolderItemCount.vue";
import FolderCompletionCount
  from "%/dynamic-component-editor/standard-pages/story-page/FolderCompletionCount.vue";
import FolderPosition
  from "%/dynamic-component-editor/standard-pages/story-page/FolderPosition.vue";
import StoryFolderFeedElement
  from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/display/StoryFolderFeedElement.vue";
import NumCompleteInFolder
  from "%/dynamic-component-editor/standard-pages/story-page/NumCompleteInFolder.vue";
import NumIncompleteInFolder
  from "%/dynamic-component-editor/standard-pages/story-page/NumIncompleteInFolder.vue";
import ParentStoryTitle
  from "%/dynamic-component-editor/standard-pages/story-page/ParentStoryTitle.vue";
import Comments from "%/dynamic-component-editor/standard-components/comments-widget/Comments.vue";
import CommentInput from "%/dynamic-component-editor/standard-elements/comments-widget/CommentInput.vue";
import SubmitCommentButton from "%/dynamic-component-editor/standard-components/comments-widget/SubmitCommentButton.vue";
import AddCommentButton from "%/dynamic-component-editor/standard-elements/comments-widget/AddCommentButton.vue";
import CancelCommentButton from "%/dynamic-component-editor/standard-elements/comments-widget/CancelCommentButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyStory extends LegacyEntity {

  get elements() {
    return {
      AuthorAvatar,
      AuthorName,
      StoryTitle,
      StoryImage,
      StoryMedia,
      StoryCreated,
      PublicationName,
      StoryContent,
      StoryBody,
      EstimatedReadingTime,
      HashTags,
      EditArticleButton,
      ExclusiveBadge,
      StoryButton,
      CompletionSetNotStarted,
      CompletionSetStarted,
      CompletionSetComplete,
      CompletionStatus,
      CompletionToggle,
      CompletionProgress,
      CompletionPercentage,
      ResumeReadingCta,
      ResumeCard,
      WorkoutSetLogger,
      WorkoutSetProgress,

      DownvoteAction,
      UpvoteAction,
      LikeAction,
      ReportAction,
      ModerationStateBadge,
      ShareButton,
      SelectCollectionButton,
      SaveAction,
      CommentAction,

      DownvoteScore,
      UpvoteScore,
      VoteScore,
      LikeCount,
      CommentCount,
      SaveCount,
      ShareCount,

      CommentsWidget,
      Comments,
      CommentInput,
      SubmitCommentButton,
      AddCommentButton,
      CancelCommentButton,
      FolderContents,
      FolderItemCount,
      FolderCompletionCount,
      FolderPosition,
      StoryFolderFeedElement,
      NumCompleteInFolder,
      NumIncompleteInFolder,
      ParentStoryTitle,
    };
  }
}

